import React from 'react';
import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';

const NAV_ITEMS = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
];

const SOCIALS = [
  { href: 'https://github.com/Esosa-web', Icon: FiGithub, label: 'GitHub' },
  { href: 'https://www.linkedin.com/in/esosa-emwionkpa-0ab5b3326/', Icon: FiLinkedin, label: 'LinkedIn' },
  { href: 'mailto:esosaemwionkpa@gmail.com', Icon: FiMail, label: 'Email' },
];

export default function LeftPanel({ activeSection, onNavClick }) {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '96px 0',
      }}
    >
      {/* Top: Name + title + tagline + nav */}
      <div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1
            onClick={() => onNavClick('about')}
            style={{
              fontSize: '48px',
              fontWeight: 700,
              color: '#e2e8f0',
              letterSpacing: '-0.025em',
              lineHeight: 1.1,
              marginBottom: '12px',
              cursor: 'pointer',
            }}
          >
            Esosa Emwionkpa
          </h1>
          <h2
            style={{
              fontSize: '20px',
              fontWeight: 500,
              color: '#e2e8f0',
              marginBottom: '16px',
            }}
          >
            Full Stack Software Engineer
          </h2>
          <p
            style={{
              fontSize: '16px',
              color: '#94a3b8',
              lineHeight: 1.6,
              maxWidth: '300px',
            }}
          >
            I build scalable web applications and data-driven platforms with clean architecture and intuitive user experiences.
          </p>
        </motion.div>

        {/* Nav */}
        <nav style={{ marginTop: '56px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {NAV_ITEMS.map(({ id, label }, i) => {
            const isActive = activeSection === id;
            return (
              <motion.button
                key={id}
                onClick={() => onNavClick(id)}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: 0.1 + i * 0.08 }}
                className="group"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                <span
                  style={{
                    height: '1px',
                    width: isActive ? '64px' : '32px',
                    backgroundColor: isActive ? '#e2e8f0' : '#64748b',
                    transition: 'all 0.3s ease',
                    display: 'block',
                  }}
                />
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: 700,
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    color: isActive ? '#e2e8f0' : '#64748b',
                    transition: 'color 0.2s ease',
                  }}
                >
                  {label}
                </span>
              </motion.button>
            );
          })}
        </nav>
      </div>

      {/* Bottom: Socials */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        style={{ display: 'flex', gap: '20px' }}
      >
        {SOCIALS.map(({ href, Icon, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            style={{ color: '#94a3b8', transition: 'color 0.2s ease, transform 0.2s ease', display: 'flex' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#e2e8f0';
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#94a3b8';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <Icon size={20} />
          </a>
        ))}
      </motion.div>
    </div>
  );
}
